class l extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M3.041 4.588 7.5 3.393V3a.5.5 0 1 1 1 0v.125L12.7 2l.259.966-.584.156L14.17 6.23a4.52 4.52 0 0 0 .631-.515l.7.714A5.484 5.484 0 0 1 11.65 8a5.476 5.476 0 0 1-3.15-.99V13H13v1H3v-1h4.5V9.01a5.476 5.476 0 0 1-3.15.99C2.851 10 1.492 9.4.5 8.428l.7-.714c.166.163.345.313.535.449l1.546-2.678-.24-.897Zm4.459-.16v3.286a4.51 4.51 0 0 1-.63.515L5.052 5.084 7.5 4.43Zm1 1.286c.166.163.345.313.535.449l1.466-2.538L8.5 4.16v1.553Zm1.408.937 1.675-2.9 1.7 2.944A4.489 4.489 0 0 1 11.65 7a4.486 4.486 0 0 1-1.742-.35Zm-5.625-.9-1.675 2.9A4.488 4.488 0 0 0 4.35 9c.576 0 1.127-.108 1.633-.305l-1.7-2.945Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-mod-legislation";
customElements.get(e) || customElements.define(e, l);
export {
  l as default
};
